import {api} from "../api";
import {TaskDropdown} from "./taskDropdown";
import {TreeDropdown, TreeDropdownConfig, TreeDropdownURLs} from "../ui/treeDropdown";
import {mergeProperties} from "@/shared/utils/misc";
import {getISODate, Temporal} from "@/shared/utils/datefunctions";
import {Task} from "@/shared/timr";
import {EVENT_RECOMMENDED_TASK_SELECTED, loadAndDisplayRecommendedTasks} from "@/shared/task/taskRecommendationHelper";

export interface TaskDropdownWithRecommendationsConfig extends TreeDropdownConfig {
	allowSelectionOfNotBookable: boolean;
	groupId?: number;
	userId?: number;
	hideInactive: boolean;
	getReferenceDate?: () => Temporal.ZonedDateTime;
}

export class TaskDropdownWithRecommendations extends TaskDropdown {

	private getProjectTimeCountRequest: JQuery.jqXHR;
	private hasProjectTimes: boolean = false;

	constructor(public config: TaskDropdownWithRecommendationsConfig, urls: TreeDropdownURLs) {
		super(mergeProperties(
			{
				classDropdownElement: "dropdown-menu-with-recommendations"
			}, config
		), urls);
		this.initListeners();
		this.updateProjectTimeCount();
	}

	public updateProjectTimeCount() {
		this.getProjectTimeCountRequest?.abort();

		this.getProjectTimeCountRequest = api("recording/hasProjectTimesForRecommendations.json")
			.get({referenceDate: getISODate(this.config.getReferenceDate())})
			.done((hasProjectTimes: boolean) => {
				this.hasProjectTimes = hasProjectTimes;
			})
			.fail(() => this.hasProjectTimes = false);
	}

	public closeDropdown() {
		super.closeDropdown();
		this.config.rootElement.find("[data-tasks-query]").removeClass("open");
		this.config.rootElement.find("[data-tasks-dropdown-area]").removeClass("open");
	}

	protected openDropdown() {
		super.openDropdown();
		this.setBorderRadius();
		this.setTaskTreeWidth();
		// prevent flickering if no project times are available
		this.config.rootElement.find("[data-tasks-dropdown]").toggleClass("no-recommendations-found", !this.hasProjectTimes);
		this.config.rootElement.find("[data-tasks-dropdown-column]")
			.toggleClass("col-xs-8", this.hasProjectTimes)
			.toggleClass("col-xs-12", !this.hasProjectTimes);

		void loadAndDisplayRecommendedTasks(
			$(this),
			this.config.rootElement.find("[data-recommended-tasks]"),
			this.config.rootElement.find("[data-recent-tasks]"),
			this.config.getReferenceDate ? this.config.getReferenceDate() : null,
			this.hasProjectTimes
		).then(recommendationsFound => {
			this.config.rootElement.find("[data-tasks-dropdown]").toggleClass("no-recommendations-found", !recommendationsFound);
		});
	}

	private initListeners() {
		$(this).on(EVENT_RECOMMENDED_TASK_SELECTED, (e, task: Task) => {
			this.closeDropdown();
			if (this.getSelectedId() !== task.id) {
				this.setSelectedId(task.id);
				this.selectedData = task;
				this.updateDescription(task.name, task.breadCrumbs);
				$(this).triggerHandler(TreeDropdown.EVENT_SELECTED, [task]);
			}
		});

		$(window).resize(() => this.dropdownIsOpen && this.setBorderRadius());
	}

	private setBorderRadius() {
		this.config.rootElement.find("[data-tasks-query]").addClass("open");
		this.config.rootElement.find("[data-tasks-dropdown-area]").addClass("open");
	}

	private setTaskTreeWidth() {
		const treeView = this.config.rootElement.find(".with-recommendations");
		const referenceWidth = Math.round(this.config.rootElement.width()) + "px";
		treeView.css("max-width", referenceWidth);
	}
}
